export enum QstTypes {
  Radio = 'radio',
  RadioInline = 'radio-inline',
  Checkbox = 'checkbox',
  DropzoneSingle = 'dropzone-single',
  DropzoneMultiple = 'dropzone-multiple',
}
